export const ticketsSalesReportConstants = {
	EXPORT_DATA: 'EXPORT_DATA',
	DOWNLOAD_DATA: 'DOWNLOAD_DATA'
}
